import React from 'react';
import classNameBind from 'classnames/bind';

import styles from './ActionBar.module.css';

const bindClasses = classNameBind.bind(styles);

const ActionBar = ({
  children,
  dataId,
}) => (
  <div className={bindClasses('ActionBar')} data-ppuc-id={dataId}>
    {children}
  </div>
);

ActionBar.defaultProps = {
  dataId: 'SearchableMultiselectListbox.ActionBar',
};

export default ActionBar;
